import React, {useState, useEffect} from 'react';
import {getReportDataAPI,getStockKeywordAPI} from "../../../apis/news_service";
import styles from "../../../assets/styles/modules/StockSummary.module.css";
import icon from "../../../assets/images/icon_black.svg";
import {Button} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { Pie, Column, Bar } from '@ant-design/plots';
import {addMycorpAPI, checkMycorpAPI, delMycorpAPI} from "../../../apis/my_service";
import toast, {Toaster} from "react-hot-toast";

const StockSummary = ({stock}) => {

    const isCorpPage = window.location.pathname.includes('/corp')
    const gappercent = isCorpPage ? stock.quotesinfo.gappercent : stock.gappercent
    const stockquotes = isCorpPage ? stock.quotesinfo.stockquotes : stock.stockquotes
    const [isSubscribe, setIsSubscribe] = useState(null) // 종목 구독 여부 체크
    const [curate, setCurate] = useState({})//큐레이팅 메시지
    const [keyword, setKeyword] = useState([])//종목 키워드
    const [report_d, setReport_d] = useState(null)// 데일리 리포트
    const [report_w, setReport_w] = useState(null)// 주간 리포트

    const notify = (msg, type) => {
        if(type === 'success') return toast.success(msg)
        else if (type === 'error') return toast.error(msg)
        else return toast(msg)
    };

    const getDailyReport = () => {
        getReportDataAPI('stocks', stock.stockcode).then(res => {
            setCurate(res.curatetext)
            if(res.newsdata.daily_data !== null && res.newsdata.weeks_data !== null){
                setReport_d(res.newsdata.daily_data)
                setReport_w(res.newsdata.weeks_data)
            }
        })
        getStockKeywordAPI(stock.stockcode).then(res => setKeyword(res))
    }

    const checkSubscribe = () => {
        checkMycorpAPI(stock.stockcode).then(res => setIsSubscribe(res))
    }

    const subscribeBtnClick = (stockcode,stockname) => {
        if(isSubscribe === true){
            delMycorpAPI(stockcode).then(() => {
                notify('마이기업 삭제가\n 완료 되었습니다.','success')
                setIsSubscribe(false)
            })
        }else if(isSubscribe === false) {
            addMycorpAPI(stockcode).then((res) => {
                if(res){
                    setIsSubscribe(true)
                    notify(stockname + ' 이/가 마이기업으로\n등록 되었습니다.\nAI 콴의 다양한 뉴스 분석 콘텐츠를\n 확인해보세요!', 'success')
                } else {
                    notify(stockname + ' 이/가 이미 존재합니다!', 'error')
                }
            })
        } else {
            notify('로그인이 필요합니다.', 'error')
        }
    }

    useEffect(checkSubscribe, [isSubscribe])
    useEffect(getDailyReport, [])


    const DemoPie = ({report}) => {
        const data = [
            {
                type: '分类一',
                value: !!report.total_pc_cnt? report_w.total_pc_cnt : 0 , //total_pc_cnt
            },

        ];
        const config = {
            appendPadding: 30,
            padding: 10,
            data,
            angleField: 'value',
            colorField: 'type',
            radius: 0.9,
            color:'rgb(217, 229, 255)',
            legend: false,
            tooltip: false,
            label: {
                type: 'inner',
                offset: '-50%',
                content:'최초보도 {value}',
            },
        };
        return <Pie {...config} height={250} />;
    };


    const DemoColumn = ({report}) => {

            const data = [
                {
                    react: '긍정',
                    cnt: !!report.positive_cnt? report_w.positive_cnt : 0 ,
                },
                {
                    react: '부정',
                    cnt: !!report.negative_cnt? report_w.negative_cnt  : 0,
                },
                {
                    react: '중립',
                    cnt: !!report.neutral_cnt? report_w.neutral_cnt : 0,
                },
            ];

            const config = {
                appendPadding: 30,
                padding: 10,
                data, //데이터
                xField: 'react',
                yField: 'cnt',
                seriesField: 'react', // 기준에 따라 막대 색상 다르게
                yAxis: false,
                label:false, // 데이터 레이블
                tooltip:false, // 툴팁
                legend: false, // 범주 표시
            };

            return <Column {...config} height={250} />;
    };


    return (
        <div className={styles.container}>
            {curate &&
                <>
                    <div className={styles.corp_container}>
                        <div className={styles.corp_header}>
                            <img src={icon} alt="corpImage"/>
                            <div className={styles.corp_info}>
                                <p className={styles.stockname}>{stock.stockname}</p>
                                <p>
                                <span className={styles.price}>
                                    {stockquotes.toLocaleString("ko-KR")}
                                </span>
                                    <span className={`${styles.percent} ${gappercent>0 ? 'positive' : 'negative'}`}>{gappercent>0 ? '▲' : '▼'} {gappercent}%</span>
                                </p>
                            </div>
                            <Button
                                className={styles.add_btn}
                                    variant='outlined' startIcon={<AddIcon/>}
                                    sx={{
                                        right: 0, height: '46px', borderRadius: '23px',
                                        border: isSubscribe ? 'none':'solid 1px #e63d44',
                                        color: isSubscribe ? '#fff' : '#e63d44',
                                        backgroundColor: isSubscribe ? '#e63d44':'#fff',
                                        '&:hover':{
                                            border: isSubscribe ? 'none':'solid 1px #e63d44',
                                            color: isSubscribe ? '#fff' : '#e63d44',
                                            backgroundColor: isSubscribe ? '#e63d44':'#fff',
                                        },
                                        '&:focus':{
                                            border: isSubscribe ? 'none':'solid 1px #e63d44',
                                            color: isSubscribe ? '#fff' : '#e63d44',
                                            backgroundColor: isSubscribe ? '#e63d44':'#fff',
                                        }
                                    }}
                                    onClick={()=>subscribeBtnClick(stock.stockcode,stock.stockname)}>
                                <span className={styles.add}>구독</span>
                            </Button>
                            <Toaster />
                        </div>
                        <div className={styles.corp_curate}>
                            <p>
                                <span>{curate.txt1}</span><br/>
                                <span>{curate.txt3}</span><br/>
                                <span>{curate.w_txt1}</span>
                            </p>
                        </div>
                        <ul className={styles.keyword_container}>
                            {keyword && keyword.map(key => <li className={styles.keyword}>{key.name}</li>)}
                        </ul>
                    </div>

                    <div className={styles.chart_container}>
                        <div className={styles.chart_header}>
                            <p className={styles.title}>7일 동안의 뉴스 보도 및 댓글 여론을 분석하였습니다.</p>
                            <p className={styles.date}>2023년 04월 14일 ~ 2023년 04월 21일</p>
                        </div>

                        <div className={styles.pie}>
                            <p>총 {!!report_w ? report_w.w_press_cnt :'0'}개의 언론사가  {!!report_w ? report_w.parents_cnt :'0'}개의 아이템을 {!!report_w ? report_w.total_pc_cnt :'0'}번 보도하였습니다.</p>
                            {report_d !== null && report_w !== null  && <DemoPie report={report_w}/>}
                        </div>
                        <div  className={styles.bar}>
                            <p>총 {!!report_w ? report_w.total_sent_cnt :'0'}개의 댓글이 작성되었습니다.</p>
                            {report_d !== null && report_w !== null  && <DemoColumn report={report_w}/>}
                        </div>
                    </div>
                </>
            }
        </div>
    )
        ;
};

export default StockSummary;